import { Button, Img, Text, Heading } from "./..";
import React from "react";

export default function PLTemplateComponent({ templateTitle = "P&L Template", fiftyText = "50", ...props }) {
  return (
    <div
      {...props}
      className={`${props.className} flex justify-center items-start w-[332px] py-1.5 border-gray-100 border-[0.5px] border-solid bg-white-a700 rounded-[12px]`}
    >
      <div className="flex flex-1 items-center justify-center gap-0.5">
        <Img src="images/img_13885f590c6070c.png" alt="Pl Template" className="h-[40px] object-cover" />
        <div className="flex flex-1 flex-col items-start justify-center gap-1">
          <Heading size="headingxs" as="p" className="!font-abhayalibreextrabold text-[12px] font-extrabold">
            {templateTitle}
          </Heading>
          <div className="flex items-center self-stretch">
            <Img src="images/img_download.svg" alt="Image" className="h-[16px] self-start" />
            <Text as="p" className="ml-1 self-end text-[12px] font-normal">
              {fiftyText}
            </Text>
          </div>
        </div>
      </div>
      <Button className="mt-1.5 flex h-[30px] w-[30px] items-center justify-center rounded-[14px] bg-deep_orange-50 px-1.5">
        <Img src="images/img_location_orange_900.svg" />
      </Button>
    </div>
  );
}
